import React from "react";
import { Link } from "react-router-dom";


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#f9f9f9] pt-[108px] pb-[50px] font-sans relative">
      
      {/* Top Logo / Divider section */}
      <div className="relative mb-16">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
           <div className="w-full border-t border-[#d5b9a1]"></div>
        </div>
        <div className="relative flex justify-center text-center">
          <span className="bg-[#f9f9f9] px-6 font-black text-[#000] tracking-[0.2em] uppercase z-10 text-[14px]">
            JETTY ESTATES
          </span>
        </div>
      </div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-16">
           <div>
             <h5 className="text-[#000] font-normal tracking-[1.6px] uppercase mb-6 text-[16px] md:text-[18px]">PROPERTIES</h5>
             <ul className="space-y-[10px] text-[14px]">
               <li><Link to="/properties/jettymayfair" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Jetty Mayfair</Link></li>
               <li><Link to="/properties" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">All Properties</Link></li>
             </ul>
           </div>
           <div>
             <h5 className="text-[#000] font-normal tracking-[1.6px] uppercase mb-6 text-[16px] md:text-[18px]">ABOUT US</h5>
             <ul className="space-y-[10px] text-[14px]">
               <li><Link to="/aboutus" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Our Story</Link></li>
               <li><Link to="/aboutus" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Leadership</Link></li>
             </ul>
           </div>
           <div>
             <h5 className="text-[#000] font-normal tracking-[1.6px] uppercase mb-6 text-[16px] md:text-[18px]">QUICK LINKS</h5>
             <ul className="space-y-[10px] text-[14px]">
               <li><Link to="/contactus" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Contact Us</Link></li>
               <li><Link to="/privacy-policy" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Privacy Policy</Link></li>
               <li><Link to="/terms-conditions" className="text-[#4f5459] text-[12px] font-light hover:text-[#c9a485] transition-colors leading-[26px]">Terms & Conditions</Link></li>
             </ul>
           </div>
        </div>

        {/* Bottom Section */}
           <div className="border-t border-gray-200 pt-6 mt-8">

              <div className="flex flex-col md:flex-row justify-between items-center gap-2">
                <div className="text-xs text-left">
                  <a
                    href="https://www.cyberspacedigital.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[12px] text-left cursor-pointer hover:underline hover:text-gray-300 transition-colors"
                  >
                    Maintained by Cyber Space Digital.<br />
                    A Development & Designer Community ( #CSD )
                  </a>
                </div>




                <div className="text-[12px]  text-center">
                  © 2018-{currentYear} jettyestates.com
                  <div className="text-xs ">All Rights Reserved</div>
                </div>



                <div className="flex  text-[12px] space-x-2">
                  <a href="/Legal/privacy-policy">Privacy Policy</a> <div className="border-r-[0.5px]" />
                  <a href="/Legal/terms-and-conditions">Terms & Conditions</a> <div className="border-r-[0.5px]" />
                  <a href="/Legal/disclaimer">Disclaimer</a> <div className="border-r-[0.5px]" />
                  <a href="/sitemap.xml">Site Map</a>
                </div>
              </div>
            </div>


      </div>
    </footer>
  );
};

export default Footer;
